import { EINREICHUNG_STORE_KEY } from '../reducers';
import { EinreichungState } from '../reducers/einreichung.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const getEinreichungState = createFeatureSelector<EinreichungState>(EINREICHUNG_STORE_KEY);
export const selectApplicationsUpdateData = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsUpdate.data,
);
export const selectApplicationsUpdateLoading = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsUpdate.loading,
);
export const selectApplicationsUpdateError = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsUpdate.error,
);
